const marketplaceRoutes = [
  {
    path: "/sales-channels",
    name: "sales.channel.store.list",
    component: () => import("@/modules/marketplace/views/ClusterHome.vue"),
    meta: {
      env: ["production"],
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/sales-channels/:uuid/management",
    name: "sales.channel.management.list",
    component: () => import("@/modules/marketplace/views/ClusterManagement.vue"),
    meta: {
      env: ["production"],
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/sales-channels/:uuid/listings/imports",
    name: "marketplace.listings.import.show",
    component: () => import("@/modules/marketplace/views/SaleChannelListingsImport.vue"),
    meta: {
      env: ["production"],
      roles: [1, 2, 5, 6],
    }
  },
];

export default marketplaceRoutes;
